import { createApp } from 'vue';

import PageHeader from './PageHeader.vue';

const componentSelector = '.page-header';

export const PageHeaderApp = () => {
  const el = document.querySelector(componentSelector);
  const { alternateLogo, navDataEncoded, pageUrlSegment } = el.dataset;
  delete el.dataset.alternateLogo;
  delete el.dataset.navDataEncoded;
  delete el.dataset.pageUrlSegment;
  createApp(
    {
      name: 'PageHeaderApp',
      components: { PageHeader },
      props: {
        alternateLogo: { type: Boolean, required: true },
        navDataEncoded: { type: String, required: true },
        pageUrlSegment: { type: String, required: true },
      },
      data() {
        return {
          navData: null,
        };
      },
      beforeMount() {
        if (!this.navDataEncoded) return;

        this.navData = JSON.parse(atob(this.navDataEncoded));
      },
      template: `<PageHeader
        :alternate-logo="alternateLogo"
        :nav-data="navData"
        :page-url-segment="pageUrlSegment"
      ></PageHeader>`,
    },
    {
      alternateLogo: !!parseInt(alternateLogo, 10),
      navDataEncoded,
      pageUrlSegment,
    }
  ).mount(componentSelector);
};

export default function init() {
  if (document.querySelector(componentSelector)) PageHeaderApp();
}
